import { Collection, Model } from 'web-mojo';

class Location extends Model {
    constructor(data = {}) {
        super(data, {
            endpoint: '/api/camaccess/location'
        });
    }

    nameOrId() {
        return this.get('name') || this.get('id');
    }

    isActive() {
        return this.get('is_active') !== false;
    }
}

class LocationList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: Location,
            endpoint: '/api/camaccess/location',
            ...options
        });
    }
}

const LocationForms = {
    edit: {
        title: 'Edit Location',
        fields: [
            { name: 'name', type: 'text', label: 'Name', columns: 12 },
            { name: 'address', type: 'text', label: 'Address', columns: 12 },
            { name: 'timezone', type: 'text', label: 'Timezone', columns: 6 },
            { name: 'contact_name', type: 'text', label: 'Contact Name', columns: 6 },
            { name: 'contact_phone', type: 'text', label: 'Contact Phone', columns: 6 },
            { name: 'contact_email', type: 'email', label: 'Contact Email', columns: 6 },
            { name: 'access_instructions', type: 'textarea', label: 'Access Instructions', columns: 12 },
            { name: 'requires_signature', type: 'checkbox', label: 'Requires Signature', columns: 12 },
        ]
    },
    create: {
        title: 'Add Location',
        fields: [
            { name: 'name', type: 'text', label: 'Name', columns: 12 },
            { name: 'address', type: 'text', label: 'Address', columns: 12 },
            { name: 'timezone', type: 'text', label: 'Timezone', columns: 6 },
            { name: 'contact_name', type: 'text', label: 'Contact Name', columns: 6 },
            { name: 'contact_phone', type: 'text', label: 'Contact Phone', columns: 6 },
            { name: 'contact_email', type: 'email', label: 'Contact Email', columns: 6 },
            { name: 'access_instructions', type: 'textarea', label: 'Access Instructions', columns: 12 },
            { name: 'requires_signature', type: 'checkbox', label: 'Requires Signature', columns: 12 },
        ]
    }
};

Location.EDIT_FORM = LocationForms.edit;
Location.ADD_FORM = LocationForms.create;

export { Location, LocationList, LocationForms };
